import { Center, Spinner, Text, VStack } from "@chakra-ui/react";
import { skipToken } from "@reduxjs/toolkit/query/react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useParams } from "react-router-dom";
import { useGetSourcingEventQuery } from "../../../../autogen/bff-api";
import { useCanManageSourcingEvent } from "../../../sourcing-event/useCanManageSourcingEvent";
import { urls } from "../../../../urls";
import { isEditableInWizard } from "../../../sourcing-event/changes/changeScope";
import { EditSourcingEventWizardForm } from "./EditSourcingEventWizardForm";

export const EditSourcingEventWizard = () => {
  const params = useParams();
  const { t } = useTranslation();

  const { data: event, isLoading, isFetching, isError, refetch } = useGetSourcingEventQuery(
    params.eventId ? { eventId: params.eventId } : skipToken
  );

  const canManage = useCanManageSourcingEvent(event);
  const hasSettledOnce = useRef(false);
  if (!isFetching) hasSettledOnce.current = true;

  if (!params.eventId) return <div>{t("404 event not found")}</div>;

  if (isLoading || !hasSettledOnce.current) {
    return (
      <Center h="40vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (isError || !event) {
    return (
      <Center h="40vh">
        <VStack>
          <Text>{t("Could not load event")}</Text>
        </VStack>
      </Center>
    );
  }

  if (!isEditableInWizard(event) || !canManage) {
    return <Navigate to={urls.app.sourcingEvents.view.go(event.id)} replace />;
  }

  return <EditSourcingEventWizardForm key={event.id} eventId={event.id} event={event} refetch={refetch} />;
};
